// import { nanoid } from "nanoid";
import React from "react";
import { Component } from "react";
// import { Modal } from "react-bootstrap";
import { checkTextTranslation, checkTranslation, translate } from "../../utils/useful";
// import FixedView from "../FixedView";
// import Modal from "../Modal";
// import inputComponents from "./inputComponents";
// import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from "../../utils/functions";
// import SidebarView from "../SidebarView";
// import FilterItems from "./FilterItems";
// import SaveFilter from './SaveFilter'
// import LoaderButton from "../LoaderButton";
// import ButtonAnimated from "../buttons/ButtonAnimated";
import FilterEditorInput from "./FilterEditorInput";
import HttpServices from "../../utils/Http.services";



class FilterInput extends Component {
    state = {

        // data: {
        //     root: {
        //         id: 'root',
        //         action: translate('and'),
        //         conditions: {}
        //     }
        // },

        tempData: {},
        filters: [],
        // columns: [],


        // inputHeader: {
        //     type: 'TextInput'
        // },

        // items: [
        //     { item: '{{lang}}Name', src: '/assets/icons/name.svg' },
        //     { item: '{{lang}}Priority', src: '/assets/icons/priority.svg' },
        //     { item: '{{lang}}Flagged', src: '/assets/icons/flagged.svg' },
        //     { item: '{{lang}}Assignee', src: '/assets/icons/assignee.svg' },
        //     { item: '{{lang}}Start date', src: '/assets/icons/calendar.svg' },
        //     { item: '{{lang}}Date', src: '/assets/icons/calendar.svg' }
        // ],
        // condition: [
        //     { item: 'contains' },
        //     { item: 'does not contain' },
        //     { item: 'is' },
        //     { item: 'is not' },
        //     { item: 'is empty' },
        //     { item: 'is not empty' }
        // ],
        // slectedCell: [],
        // labela: '',
        // calca: '',
        // selectedChoose: false,
        // selectedCalc: false,
        // calc: [
        //     { title: '{{lang}}Equal', value: 'Equal' },
        //     { title: '{{lang}}Less Than', value: 'Less Than' },
        //     { title: '{{lang}}More Than', value: 'More Than' },
        //     { title: '{{lang}}Equal of less than', value: 'Equal of less than' },
        //     { title: '{{lang}}Equal of more than', value: 'Equal of more than' },
        //     { title: '{{lang}}Contains', value: 'Contains' },
        // ],
        // save: [
        //     { name: 'test', image: "/assets/icons/more-black.svg" },
        //     { name: 'number', image: "/assets/icons/more-black.svg" },
        //     { name: 'test2', image: "/assets/icons/more-black.svg" },
        //     { name: 'heiskj', image: "/assets/icons/more-black.svg" }
        // ]
    }

    componentDidMount() {
        // let current = { level: 0, groupId: 'root', parents: [] }
        if (this.props.data) {
            this.setState({ data: this.props.data })
        }
        // else {
        //     this.setState({ current }, () => {
        //         this.doAdd('con', current)
        //     })
        // }
        // this.setState({ items: this.props.headers }, () => {
        // });
        this.init()

    }


    componentDidUpdate(prevProps) {

        let frames = this.props.header?.information?.frame ?? this.props.header?.information?.frames
        if (this.state.paramFrames != frames) {
            this.init()
        }
        if (prevProps.data != this.props.data) {
            this.setState({ data: this.props.data })
        }
    }


    init() {

        let frames = this.props.header?.information?.frame ?? this.props.header?.information?.frames

        this.setState({ paramFrames: frames })
        let fullParams = {}//this.props.params ? JSON.parse(JSON.stringify(this.props.params)) :[]

        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                fullParams[param.value] = { key: param.key ?? param.value, label: param.label, list: param.fields ?? param.list, info: param.info }
            }
        }

        // console.log(fullParams)

        // console.log(this.props.header?.information?.frame)
        if (frames) {
            let body = { filter: {} }

            if (!Array.isArray(frames)) {
                body.filter._id = [frames]
            } else {
                body.filter._id = frames
            }

            // console.log(body)


            HttpServices.request('getFrames', body, (fetchResult, fetchError) => {


                this.setState({ isLoadingHeaders: false })
                if (fetchError) {
                    this.setState({ fetchError })
                    return
                }

                // let fields = fetchResult?.info?.fields

                // console.log(fetchResult.info)

                // let params =  []
                let fields = []


                // TO DO: CONSIDER ADDING THE FRAMES NAMES TO INDICATED DIFFERENT KEYS
                if (Array.isArray(fetchResult.info)) {
                    // console.log(fetchResult.info)
                    fetchResult.info.forEach(frame => {

                        // console.log(frame?.fields)
                        if (Array.isArray(frame?.fields)) {

                            let foundId = false

                            for (let a = 0; a < frame.fields.length; a++) {
                                const element = frame.fields[a];
                                if (element?.key == '_id') {
                                    foundId = true
                                }
                            }

                            if (!foundId) {
                                frame.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
                                frame.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
                                frame.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
                            }

                            frame.fields.forEach(frameField => {

                                if (frameField.type != 'StaticText') {
                                    let found = false
                                    let myParamsFields = fields ?? []

                                    myParamsFields.forEach(paramField => {

                                        // TO DO: should be checked based on key and we can group them based on applet (??)
                                        if (frameField?.key == paramField?.key) {
                                            found = true
                                        }
                                    });

                                    if (!found) {
                                        fields.push(frameField)
                                    }
                                }

                            });


                        }
                        // myParams.fields = [...(myParams.fields ?? []), ...(frame?.fields ?? [])]

                    });
                }

                // console.log(fields)
                // let myParams = { label: "View Record", value: 'record', fields: fetchResult.info?.fields, info: fetchResult.info }

                // console.log(fields)

                // fullParams['*current'] = { label: "Current Record", key: '*current', list:fields,  }

                this.setState({ items: fields, fullParams }, () => { })



            })
        } else {
            this.setState({ items: [], fullParams }, () => { })
        }
        // this.setState({ items: this.props.headers })
        // let element
        // for (let i = 0; i < this.props.headers?.length; i++) {
        //     // element = this.props.headers[i];

        //     // this.setState({ slectedCell: element }, () => {
        //     // })
        // }
    }



    // saveAction = () => {
    //     this.saveSidebar.open()
    // }

    // selectHandler = (item) => {
    //     let items = this.state.items
    //     items.push(item)
    // }

    // doDone = () => {
    //     this.setState({ tempData: -1 }, () => {
    //         this.props.changeValue(this.props.header?.key, this.state.data, this.props.extra)
    //     })
    // }

    // openAdd = (id, parents, level) => {
    //     this.setState({ currentNode: this['add-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.fixedView.showView()
    //     })
    // }

    // openActionsView = (id, parents, level) => {
    //     this.setState({ currentNode: this['action-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.actionsView.showView()
    //     })
    // }

    // doAdd = (type, current) => {
    //     if (this.fixedView) {
    //         this.fixedView.hideView()
    //     }
    //     let id = nanoid(10)

    //     let newCondition
    //     if (type == 'con') {
    //         newCondition = { id, source: null, operator: 'Equal', target: null }
    //     } else {
    //         newCondition = { id, action: 'and' }
    //     }
    //     let data = this.state.data
    //     // let current = this.state.current
    //     current.id = id


    //     this.actionOnChild(data, current, newCondition, 'add', 0)


    //     this.setState({ data: data })
    // }

    // changeAction = (type) => {

    //     let data = this.state.data
    //     let current = this.state.current
    //     this.actionOnChild(data, current, type, 'changeOperator', 0)
    //     this.setState({ data })
    //     if (this.actionsView) {
    //         this.actionsView.hideView()
    //     }
    // }

    // removeRow = (groupId, id, parents) => {
    //     let current = { groupId, id, parents }
    //     let data = this.state.data

    //     this.actionOnChild(data, current, null, 'remove', 0)
    //     this.setState({ data: data })

    // }

    // openInput = (key, id, groupId, parents) => {
    //     let current = { groupId, id, parents, key }
    //     let data = this.state.data
    //     let value = this.actionOnChild(data, current, null, 'get', 0)

    //     let inputHeader = {
    //         type: 'SmartInput'
    //         , information: {}
    //     }

    //     if (key == 'operator') {
    //         inputHeader = {
    //             type: 'SelectInput', information: {
    //                 type: 'local', items: [
    //                     { title: '{{lang}}Equal', value: 'Equal' },
    //                     { title: '{{lang}}Less Than', value: 'Less Than' },
    //                     { title: '{{lang}}More Than', value: 'More Than' },
    //                     { title: '{{lang}}Equal or less than', value: 'Equal of less than' },
    //                     { title: '{{lang}}Equal or more than', value: 'Equal of more than' },
    //                     { title: '{{lang}}Contains', value: 'Contains' },
    //                 ]
    //             }
    //         }
    //     }

    //     this.setState({ inputHeader, currentNode: this[key + '-' + id], current: { id, groupId, parents, key, value } }, () => {
    //         this.inputView.showView()
    //     })
    // }

    // changeInputValue = (key, value) => {

    //     let current = this.state.current
    //     let data = this.state.data
    //     // let value = target.value

    //     this.actionOnChild(data, current, value, 'update', 0)
    //     current.value = value//target.value
    //     this.setState({ data, current })
    // }

    // actionOnChild(data, current, value, action, index) {

    //     if (index == current.parents.length) {

    //         if (action == 'add') {

    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             if (!data[current.groupId].conditions) {
    //                 data[current.groupId].conditions = {}
    //             }
    //             data[current.groupId].conditions[current.id] = value

    //         }

    //         if (action == 'remove') {
    //             if (current.id == null) {
    //                 delete data[current.groupId]
    //             } else {
    //                 delete data[current.groupId].conditions[current.id]
    //             }
    //         }

    //         if (action == 'changeOperator') {
    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             data[current.groupId].action = value
    //         }

    //         if (action == 'update') {
    //             data[current.groupId].conditions[current.id][current.key] = value
    //         }

    //         if (action == 'get') {
    //             return data[current.groupId].conditions[current.id][current.key]
    //         }

    //     } else if (index < current.parents.length) {
    //         let newData = data[current.parents[index]]
    //         if (newData) {
    //             return this.actionOnChild(newData.conditions, current, value, action, index + 1)
    //         }
    //     }
    // }

    // getLabel(prop, key) {
    //     let label = prop[key]
    //     let hasValue = true
    //     if (!label) {
    //         label = translate('Choose')
    //         hasValue = false
    //     }
    //     return { label, hasValue }
    // }

    // setData = (item) => {
    //     this.setState({ labela: item, selectedChoose: true, selectedCalc: true, calca: item })
    // }

    // renderGroup(data, parents, level) {
    //     if (data) {
    //         return (
    //             <div className="position-relative">
    //                 {data.action && (
    //                     <div className="flexcb" style={{ justifyContent: 'right' }}>
    //                         {level != 0 && (
    //                             <>
    //                                 <button onClick={() => this.removeRow(data.id, null, parents, level)} className=" flexcc" style={{ position: "absolute", top: 17, left: -20.5, backgroundColor: "#f6f6f6", width: 12, height: 12, borderRadius: 3 }} >
    //                                     <p className="flexcc" style={{ color: "#FF3B30" }}>&times;</p>
    //                                     {/* <img width={16} src="/assets/icons/trash.svg"/> */}
    //                                 </button>
    //                             </>
    //                         )}
    //                     </div>
    //                 )}
    //                 <div className="" style={{ backgroundColor: "transparent" }}>
    //                     {data.conditions && Object.values(data.conditions).map((prop, index) => {
    //                         if (prop) {
    //                             if (prop.action) {
    //                                 return (
    //                                     <div key={prop.id} className="px-2 pb-2 my-2 " style={{ background: '#fff', color: '#000', border: '1px solid rgba(0,0,0,0.1)', width: "100%", borderRadius: '10px' }} >
    //                                         {this.renderGroup(prop, [...parents, data.id], level + 1)}
    //                                     </div>
    //                                 )
    //                             }
    //                             else {
    //                                 return (
    //                                     <div className="w-100" key={index}>
    //                                         <FilterItems calc={this.state.calc} selectedChoose={this.state.selectedChoose} label={this.state.labela} calca={this.state.calca} setData={this.setData} getlabel={this.getLabel} changeAction={this.changeAction} items={this.state.items} renderGroup={this.renderGroup} removeRow={this.removeRow} headers={this.props.headers} prop={prop} index={index} level={level} data={data} parents={parents} openInput={this.openInput} openActionsView={this.openActionsView} />
    //                                     </div>

    //                                 )
    //                             }

    //                         }

    //                     }
    //                     )}
    //                 </div >
    //                 {data.action && (
    //                     <div className="flexc pt-2" style={{ opacity: '100%' }} >
    //                         <div ref={el => this['add-' + data.id] = el} className="w-100">
    //                             <div className="flexcb w-100">
    //                                 <button className="flexcc pld-2 prd-4 py-2 br-20" style={{ border: '1px solid #007aff' }} onClick={() => this.doAdd('con', { level: level, groupId: data.id, parents: parents })}>
    //                                     <img className="" src="/assets/icons/plus-blue.svg" width="16px" />
    //                                     <p className="pld-1 text-smaller font-size-12" style={{ color: "#007aff" }}>{translate('Condition')}</p>
    //                                 </button>
    //                                 <button className="flexcc pld-2 prd-4 py-2 br-20" style={{ border: '1px solid #007aff' }} onClick={() => this.doAdd('group', { level: level, groupId: data.id, parents: parents })}>
    //                                     <img className="" src="/assets/icons/plus-blue.svg" width="16px" />
    //                                     <p className="pld-1 text-smaller font-size-12" style={{ color: "#007aff" }}>{translate('Condition group')}</p>
    //                                 </button>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 )}
    //             </div>
    //         )
    //     }
    // }


    generateVisual(data) {
        if (data) {
            return this.generateGroupVisual(data.root)
        } else {
            return " "
        }
    }

    generateGroupVisual(group) {
        let text = ""
        if (group && group.conditions && typeof group.conditions == 'object') {
            // text = '('
            Object.values(group.conditions).forEach((oneInGroup, index) => {
                let onInGroupSource = ''

                this.props.headers.forEach(el => {
                    if (el.key == oneInGroup.source) {
                        onInGroupSource = el?.information?.label
                        return
                    }
                });
                if (index != 0) {
                    if (group.action == 'and') {
                        text = text + " & "
                    }
                    if (group.action == 'or') {
                        text = text + " | "
                    }
                }

                if (oneInGroup.action) {
                    text = translate('Multiple filters')
                    // text = text + this.generateGroupVisual(oneInGroup)
                } else {

                    text = text + onInGroupSource + " " + oneInGroup.operator
                    if (oneInGroup.target && oneInGroup.target != null) {
                        text = text + " " + oneInGroup.target
                    }
                    // text = text + oneInGroup.source + " " + oneInGroup.operator + " " + oneInGroup.target
                }
            });
            // text = text + ")"
        }
        // this.props.setData('filters', filters,'CollectionView')
        return text
    }


    open = () => {
        this.filterEditor.open()
    }
    applyFilter = () => {
        if (this.props.functionsHandler) {
            // this.props.setData('hasFilter', true, 'CollectionView', () => {
            // console.log('hiiiiiiiiiii', this.generateGroupVisual(this.state.data.root))
            // return

            this.props.functionsHandler(null, 'fetchData', this.state.data, true, () => {
                let filters = []
                filters.push(this.generateGroupVisual(this.state.data.root))
                this.setState({ filters })
                this.props.setData('filters', filters, 'CollectionView', () => {
                    this.filterEditor.closeSidebar()
                    // })
                })
            })
        }
    }


    changeValue = (key, value, extra) => {

        // this.setState({ [key]: value })
        this.props.changeValue(this.props.header.key, value, this.props.extra)
        if (value == null) {
            this.setState({ showFilter: false })
        }
        // this.setState({ data: value })
    }





    render() {

        return (
            <div className="w-100" >
                {/* {console.log(this.state.items)} */}
                {(!this.props.data && !this.props.data?.root && !this.state.showFilter) && (
                    <button className="flexc px-1" onClick={() => this.setState({ showFilter: true })}>
                        <p className="text-link">{checkTranslation(this.props.header?.information?.placeholder ?? '{{lang}}Add filter')}</p>
                    </button>
                )}
                {(this.props.data?.root || this.state.showFilter) && (
                    <div className="px-1 mt-1">
                        <FilterEditorInput data={this.props.data} params={this.state.items} fullParams={this.state.fullParams} changeValue={this.changeValue} variables={this.props.variables} />
                    </div>
                )}
            </div>

        )
    }
}

export default FilterInput;